import { TemplateRef } from '@angular/core';

export interface IInputList {
  value: any;
  text?: string;
  template?: TemplateRef<any>;
  cssClass?: string;
  image?: string;
  icon?: string;
  item?: any;
}

export interface IInputCheckedModel {
  key: any;
  checked: boolean;
}
